
import { priceToString } from "../Common.js";
import { toLocalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";

export function price(p, currency) {
    if (p == null) {
        return "";
    }
    else {
        return priceToString(p, currency);
    }
}

export function purchaseDate(d) {
    if (d == null) {
        return "";
    }
    else {
        return toString(toLocalTime(d), "dd.MM.yyyy");
    }
}

